export var FeatureCode;
(function (FeatureCode) {
    FeatureCode["QRSCANNING"] = "QR-SCANNING";
    FeatureCode["CORE"] = "CORE";
    FeatureCode["ESCALATIONS"] = "ESCALATIONS";
    FeatureCode["OPERATIONAL_INSIGHTS"] = "OPERATIONAL-INSIGHTS";
    FeatureCode["DATE_ENTRY_CHECK"] = "DATE-ENTRY-CHECK";
    FeatureCode["HUB_USE_AWS_IOT_STACK"] = "IOT-STACK";
    FeatureCode["SENSOR_MISCOMS_ALERTS"] = "ZIGBEE-MISCOM-ALERT";
    FeatureCode["PHOTO_UPLOAD"] = "PHOTO";
    FeatureCode["MANUAL_TEMPERATURE"] = "MANUAL-TEMPERATURE";
    FeatureCode["AM_ALERTS_ON_MEMO"] = "AM-MEMO-REPORTING";
    FeatureCode["HUB_USE_HTTPS"] = "HUB-WEBSERVER-HTTPS";
    FeatureCode["MEMO_USE_AWS_IOT_STACK"] = "WM-REPORTS-IOT";
})(FeatureCode || (FeatureCode = {}));
//# sourceMappingURL=features.js.map